import { ThemeColors } from "consts/theme";
import { PaziaTooltip } from "components/atoms";

interface PaziaChipProps {
  children: React.ReactNode;
  color?: "slate" | "primary";
  onClick?: () => void;
  tooltip?: string;
}

const ChipsColors: { [key in ThemeColors]: string } = {
  slate: `border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm 
  bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400`,
  primary: "border-transparent shadow-sm bg-primary-500 text-white",
  indigo: "", // TODO
  emerald: "",
  amber: "",
  white: "",
};

export const PaziaChip = ({ children, onClick, tooltip, color = "slate" }: PaziaChipProps) => {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center justify-center text-sm font-medium 
      leading-5 rounded-full px-3 py-1 border duration-150 ease-in-out ${ChipsColors[color]}`}
    >
      {children}
      {tooltip && <PaziaTooltip description={tooltip} />}
    </button>
  );
};
